import * as React from "react";
const MobilePhone = props => <symbol viewBox="0 0 24 24" {...props}>
    <g>
      <path d="M15.75 2.25h-7.5A2.753 2.753 0 005.5 5v14a2.753 2.753 0 002.75 2.75h7.5A2.752 2.752 0 0018.5 19V5a2.752 2.752 0 00-2.75-2.75zM17 19a1.25 1.25 0 01-1.25 1.25h-7.5A1.251 1.251 0 017 19V5a1.251 1.251 0 011.25-1.25h7.5A1.251 1.251 0 0117 5z" />
      <path d="M14.5 17.25h-5a.75.75 0 100 1.5h5a.75.75 0 100-1.5z" />
    </g>
  </symbol>;
export default MobilePhone;